import { jsx as _jsx } from "react/jsx-runtime";
import '@/styles/UI/Loader.css';
import { Icon } from '@/assets/icons/LibrarySvg';
const Loader = () => (_jsx("div", { className: "loader-container", children: _jsx(Icon, { name: "loader_dots_fade" }) }));
export default Loader;
